import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const ArrowRightCompactIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.46967 2.21967C5.76256 1.92678 6.23744 1.92678 6.53033 2.21967L11.7803 7.46967C12.0732 7.76256 12.0732 8.23744 11.7803 8.53033L6.53033 13.7803C6.23744 14.0732 5.76256 14.0732 5.46967 13.7803C5.17678 13.4874 5.17678 13.0126 5.46967 12.7197L10.1893 8L5.46967 3.28033C5.17678 2.98744 5.17678 2.51256 5.46967 2.21967Z"
      fill="CurrentColor"
    />
  </IconBase>
);

export default ArrowRightCompactIcon;
